module.exports = __webpack_public_path__ + "static/media/partners.1a95f5a9.jpg";